import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, H3, BlueButton } from '../../StyledComponents';
import Automated from '../../../assets/Retail/automated.svg';
import Lock from '../../../assets/Retail/lockdevices.svg';
import Remote from '../../../assets/Retail/remotedebug.svg';
import Alerts from '../../../assets/Retail/alerts.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { navigate } from '@reach/router';

const Section = styled(SectionParent)`
  padding: 0rem 20rem;
  display: grid;
  justify-items: center;
  width: 100%;
  background-color: #2a2f46;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 16rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 4rem;
    padding-right: 4rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    padding-bottom: 2rem;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-top: 2rem;
  width: 100%;
  padding-left: 5rem;
  padding-right: 5rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  @media (max-width: 520px) {
    padding-left: 0rem;
    padding-right: 0rem;
    grid-template-columns: repeat(2, 1fr);
    padding-top: 0rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  min-width: 220px;
  /* margin-right: 1rem;
  margin-left: 1rem; */
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    min-width: unset;
  }
`;

const GridItemTitle = styled(H2)`
  font-weight: normal;
  font-size: 1.5em;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;

  min-height: 3rem;
  margin-top: 0.5rem;
  margin-bottom: 0.8rem;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 16px;
  }
  @media (max-width: 375px) {
    font-size: 15px;
  }
`;
const imageStyle = {
  height: '98px',
  width: '86px',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
`;
const BottomButton = styled(BlueButton)`
  background-color: #725cbd;
`;
const BlueButtonWrapper = styled.div`
  margin-bottom: 3rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-bottom: 0;
  }
`;
export default () => (
  <Section>
    <GridContainer>
      <GridItem>
        <ImgContainer>
          <LazyLoadImage
            alt="Automated and Seamless Deployment"
            src={Automated}
            style={imageStyle}
          />
        </ImgContainer>
        <GridItemTitle>
          Automated and <br />
          Seamless Deployment
        </GridItemTitle>
      </GridItem>
      <GridItem>
        <ImgContainer>
          <LazyLoadImage
            alt="Lock Devices and Gain Complete Control"
            src={Lock}
            style={imageStyle}
          />
        </ImgContainer>
        <GridItemTitle>
          Lock Devices and Gain <br />
          Complete Control{' '}
        </GridItemTitle>
      </GridItem>
      <GridItem>
        <ImgContainer>
          <LazyLoadImage
            alt="Remote Control and Debugging"
            src={Remote}
            style={imageStyle}
          />
        </ImgContainer>
        <GridItemTitle>
          Remote Control and <br />
          Debugging
        </GridItemTitle>
      </GridItem>
      <GridItem>
        <ImgContainer>
          <LazyLoadImage
            alt="Set Alerts For Device Issues"
            src={Alerts}
            style={imageStyle}
          />
        </ImgContainer>
        <GridItemTitle>
          Set Alerts For
          <br /> Device Issues
        </GridItemTitle>
      </GridItem>
    </GridContainer>
    <BlueButtonWrapper>
      <BottomButton
        id="retail__signup_for_free"
        onClick={() => navigate('/signup')}
      >
        {' '}
        Sign up for free
      </BottomButton>
    </BlueButtonWrapper>
  </Section>
);
